import { Injectable } from '@angular/core';
import { ApiService } from '@meddatacore/common';
import { Passport } from '../../models';


@Injectable({
    providedIn: 'root',
})
export class PassportService extends ApiService {

    get(id: string) {
        return this.http.get(`${this.persionBaseURL}/api/passport/${id}`);
    }
    
    getPersonPassport(personId: string) {
        return this.http.get(`${this.persionBaseURL}/api/passport/persons/${personId}/passport`);
    }

    create(address: Passport) {
        return this.http.post(`${this.persionBaseURL}/api/passport`, address);
    }

    update(address: Passport) {
        return this.http.put(`${this.persionBaseURL}/api/passport`, address);
    }
}
